import React, { useEffect, useState } from "react";
import Loading from "../components/common/Loading";
import InfiniteScroll from "react-infinite-scroll-component";
import { httpReauest } from "../utils/httpRequest";
import { Shamsi } from "basic-shamsi";
import { CDN_BASE_URL } from "../config";
import CustomModal from "../components/common/Modal";
import { FaAngleDown, FaEdit, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { priceComma } from "../utils/priceComma";
import { BiCopy } from "react-icons/bi";
import { Link } from "react-router-dom";

const UsersManagePage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState();
  const [hasmore, sethasmore] = useState(true);
  const [show, setShow] = useState(false);
  const [selected, setselcted] = useState();
  const [edit, setedit] = useState(false);
  const [balance, setbalance] = useState(selected?.balance);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "GET",
      "/user",
      {},
      { "x-access-token": user?.token }
    ).then(({ data }) => {
      setProducts(data.data);
    });
    setLoading(false);
  }

  async function handleNewBalance() {
    if (!balance) {
      return toast.error("مقدار خالی است");
    }
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "PUT",
      "/user/balance/" + selected?._id,
      { balance },
      { "x-access-token": user?.token }
    ).then((res) => {
      toast.success("موفقیت آمیز");
      setedit(false);
      setselcted(res.data?.data);
    });
  }

  return (
    <div>
      <div className="w-full">
        <div className=" mb-10">
          <h1 className="title">کاربر ها</h1>
        </div>

        {loading ? (
          <Loading />
        ) : (
          <div className="grid gap-3 lg:grid-cols-3">
            {selected ? (
              <>
                <button
                  className="btn-brand"
                  onClick={() => {
                    setselcted(null);
                    setedit(false);
                  }}
                >
                  بازگشت
                </button>
                <div className="col-span-full border p-4">
                  <h4 className="font-bold text-[20px]">
                    مشخصات کاربر {selected?.name}
                  </h4>
                  <span className="p-2 flex flex-wrap gap-3">
                    <span>نام و نام خانوادگی :</span>
                    <span dir="ltr">{selected?.name}</span>
                  </span>
                  <span className="p-2 flex flex-wrap gap-3">
                    <span>کد ملی:</span>
                    <span dir="ltr">{selected?.nationalCode}</span>
                  </span>
                  <span className="p-2 flex flex-wrap gap-3">
                    <span>استان:</span>
                    <span dir="ltr">{selected?.state}</span>
                  </span>
                  <span className="p-2 flex flex-wrap gap-3">
                    <span>شهر:</span>
                    <span dir="ltr">{selected?.city}</span>
                  </span>{" "}
                  <span className="p-2 flex flex-wrap gap-3">
                    <span>کد پستی:</span>
                    <span dir="ltr">{selected?.postalCode}</span>
                  </span>{" "}
                  <span className="p-2 flex flex-wrap gap-3">
                    <span>تاریخ ثبت نام :</span>
                    <span dir="ltr">
                      {" "}
                      {Shamsi.format(
                        "yyyy/MM/dd - hh:mm",
                        new Date(selected?.createdAt)
                      )}
                    </span>
                  </span>
                  <span className="p-2 flex">
                    <span>آدرس:</span>
                    <span dir="ltr">{selected?.address}</span>
                  </span>{" "}
                  {edit ? (
                    <span className="p-2 flex bg-slate-200 items-center gap-3">
                      <span>موجودی جدید:</span>
                      <input
                        className="form-brand"
                        value={balance}
                        onChange={(e) => setbalance(e.target.value)}
                        type="number"
                      />

                      <button onClick={handleNewBalance} className="btn-brand">
                        تایید
                      </button>
                    </span>
                  ) : (
                    <span className="p-2 flex bg-slate-200 items-center gap-3">
                      <span>موجودی:</span>
                      <span dir="ltr">
                        {priceComma(selected?.balance, 2)}AED
                      </span>
                      <button
                        onClick={() => setedit(true)}
                        className="btn-brand"
                      >
                        تغییر موجودی
                      </button>
                    </span>
                  )}
                  <span className="p-2 grid grid-cols-2">
                    {selected?.nationa_card && (
                      <span>
                        <span className="text-center">تصویر کارت ملی:</span>
                        <Link
                          to={CDN_BASE_URL + selected?.nationa_card}
                          target="_blank"
                          dir="ltr"
                        >
                          <img
                            className="w-full"
                            src={CDN_BASE_URL + selected?.nationa_card}
                            alt="nationalCard"
                          />
                        </Link>
                      </span>
                    )}

                    {selected?.workLicense && (
                      <span className="text-center">
                        <span>تصویر جواز کار:</span>
                        <Link
                          to={CDN_BASE_URL + selected?.workLicense}
                          target="_blank"
                          dir="ltr"
                        >
                          <img
                            className="w-full"
                            src={CDN_BASE_URL + selected?.workLicense}
                            alt="nationalCard"
                          />
                        </Link>
                      </span>
                    )}
                  </span>{" "}
                </div>
              </>
            ) : (
              products?.map((item) => (
                <div className="border rounded-[16px]">
                  <span className="w-full flex justify-center mt-1">
                    {item?.type === "Partner" ? (
                      <span className="rounded px-2 text-white bg-purple-600">
                        همکار
                      </span>
                    ) : (
                      <span className="rounded px-2 text-white bg-orange-600">
                        کاربر عادی
                      </span>
                    )}
                  </span>{" "}
                  <span className="p-2 flex justify-between flex-wrap gap-3">
                    <span>نام و نام خانوادگی :</span>
                    <span dir="ltr">{item?.name}</span>
                  </span>
                  <span className="p-2 flex justify-between flex-wrap gap-3">
                    <span>شماره تماس:</span>
                    <span dir="ltr">{item?.phone}</span>
                  </span>
                  <span className="p-2 flex justify-between flex-wrap gap-3">
                    <span>کد ملی:</span>
                    <span dir="ltr">{item?.nationalCode}</span>
                  </span>
                  <span className="p-2 flex justify-between flex-wrap gap-3">
                    <span>استان:</span>
                    <span dir="ltr">{item?.state}</span>
                  </span>
                  <span className="p-2 flex justify-between flex-wrap gap-3">
                    <span>شهر:</span>
                    <span dir="ltr">{item?.city}</span>
                  </span>{" "}
                  <span className="p-2 flex justify-between flex-wrap gap-3">
                    <span>کد پستی:</span>
                    <span dir="ltr">{item?.postalCode}</span>
                  </span>{" "}
                  <span className="p-2 flex justify-between flex-wrap gap-3">
                    <span>تاریخ ثبت نام :</span>
                    <span dir="ltr">
                      {" "}
                      {Shamsi.format(
                        "yyyy/MM/dd - hh:mm",
                        new Date(item?.createdAt)
                      )}
                    </span>
                  </span>
                  <span className="p-2 flex">
                    <span>آدرس:</span>
                    <span dir="ltr">{item?.address}</span>
                  </span>{" "}
                  <span className="p-2 grid grid-cols-2">
                    {item?.nationa_card && (
                      <span>
                        <span className="text-center">تصویر کارت ملی:</span>
                        <Link
                          to={CDN_BASE_URL + item?.nationa_card}
                          target="_blank"
                          dir="ltr"
                        >
                          <img
                            className="w-full"
                            src={CDN_BASE_URL + item?.nationa_card}
                            alt="nationalCard"
                          />
                        </Link>
                      </span>
                    )}

                    {item?.workLicense && (
                      <span className="text-center">
                        <span>تصویر جواز کار:</span>
                        <Link
                          to={CDN_BASE_URL + item?.workLicense}
                          target="_blank"
                          dir="ltr"
                        >
                          <img
                            className="w-full"
                            src={CDN_BASE_URL + item?.workLicense}
                            alt="nationalCard"
                          />
                        </Link>
                      </span>
                    )}
                  </span>{" "}
                  <span className="w-full flex justify-center mb-1">
                    <button
                      onClick={() => setselcted(item)}
                      className="rounded px-3 py-1 text-white bg-black"
                    >
                      مدیریت / تغییر <FaEdit className="inline" />
                    </button>
                  </span>{" "}
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default UsersManagePage;
